import React from 'react';

/**
 * Card and wallet marks drawn inline so the checkout row always renders crisp,
 * with no external requests and no broken images.
 */
const tile = 'flex h-8 w-[52px] items-center justify-center rounded-[3px] bg-white';
export function PaymentLogos() {
  return <ul className="flex flex-wrap items-center gap-2" aria-label="Accepted payment methods" data-id="element-1001" data-mp="7fusdjmo1x7r">
      <li className={tile} title="Visa" data-id="element-1002" data-mp="2h9p1bc4axf3">
        <svg viewBox="0 0 48 16" className="h-3 w-[38px]" role="img" aria-label="Visa" data-id="element-1003" data-mp="3atxh8d5n9b1h">
          <text x="0" y="13" fill="#1A1F71" fontFamily="Arial, Helvetica, sans-serif" fontSize="15" fontStyle="italic" fontWeight="700" letterSpacing="0.5" data-id="element-1004" data-mp="35w5lt95sj6sj">
            VISA
          </text>
        </svg>
      </li>

      <li className={tile} title="Mastercard" data-id="element-1005" data-mp="101cpq3aivqr6">
        <svg viewBox="0 0 40 24" className="h-5 w-[34px]" role="img" aria-label="Mastercard" data-id="element-1006" data-mp="104icvczlcik9">
          <circle cx="15" cy="12" r="9" fill="#EB001B" data-id="element-1007" data-mp="v5xc9cgffwva" />
          <circle cx="25" cy="12" r="9" fill="#F79E1B" data-id="element-1008" data-mp="3v2vawhciayy8" />
          <path d="M20 4.6a9 9 0 000 14.8A9 9 0 0020 4.6z" fill="#FF5F00" data-id="element-1009" data-mp="3x3ont1uo6gp" />
        </svg>
      </li>

      <li className={tile} title="American Express" data-id="element-1010" data-mp="8wq2a3llboq1">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="American Express" data-id="element-1011" data-mp="8wyerudsws0p">
          <rect width="52" height="16" rx="2" fill="#2E77BC" data-id="element-1012" data-mp="cxie94luk7q0" />
          <text x="26" y="11.5" textAnchor="middle" fill="#FFFFFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" letterSpacing="0.4" data-id="element-1013" data-mp="3cdyhefoxoah2">
            AMEX
          </text>
        </svg>
      </li>

      <li className={tile} title="Discover" data-id="element-1014" data-mp="3q5da5e8n7q1b">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="Discover" data-id="element-1015" data-mp="2tmns22yuw5ra">
          <text x="0" y="12" fill="#231F20" fontFamily="Arial, Helvetica, sans-serif" fontSize="9" fontWeight="700" data-id="element-1016" data-mp="2xo9dicpghsd3">
            DISC
          </text>
          <circle cx="44" cy="8" r="6" fill="#F26E21" data-id="element-1017" data-mp="3w0ve5yx5hfpk" />
        </svg>
      </li>

      <li className={tile} title="PayPal" data-id="element-1018" data-mp="ejc7siol5dcu">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="PayPal" data-id="element-1019" data-mp="ej2gmrrt105k">
          <text x="0" y="12" fill="#253B80" fontFamily="Arial, Helvetica, sans-serif" fontSize="11" fontWeight="700" data-id="element-1020" data-mp="9ltxanux6q2q">
            Pay
          </text>
          <text x="23" y="12" fill="#179BD7" fontFamily="Arial, Helvetica, sans-serif" fontSize="11" fontWeight="700" data-id="element-1021" data-mp="3d17rvmqwllq7">
            Pal
          </text>
        </svg>
      </li>

      <li className={tile} title="Apple Pay" data-id="element-1022" data-mp="3qywaenxi0gs3">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="Apple Pay" data-id="element-1023" data-mp="3mz5ph0unkuvh">
          <path d="M9.6 4.3c-.5.6-1.3 1-2 .9-.1-.8.3-1.6.7-2.1.5-.6 1.3-1 2-1 .1.8-.2 1.6-.7 2.2zm.7 1.1c-1.1-.1-2 .6-2.5.6-.5 0-1.3-.6-2.2-.6-1.1 0-2.2.7-2.7 1.7-1.2 2-.3 5 .9 6.6.6.8 1.2 1.7 2.1 1.6.9 0 1.2-.6 2.3-.6 1.1 0 1.3.6 2.2.6.9 0 1.5-.8 2.1-1.7.4-.6.6-1 .9-1.7-2.3-.9-2.6-4-.3-5.3-.4-.6-1-1.1-1.8-1.2z" fill="#000000" data-id="element-1024" data-mp="16a8jvh2tndz2" />
          <text x="17" y="13" fill="#000000" fontFamily="Arial, Helvetica, sans-serif" fontSize="10" fontWeight="600" data-id="element-1025" data-mp="1epfoe74weexf">
            Pay
          </text>
        </svg>
      </li>

      <li className={tile} title="Google Pay" data-id="element-1026" data-mp="14u4h29vtk9zp">
        <svg viewBox="0 0 56 16" className="h-4 w-[46px]" role="img" aria-label="Google Pay" data-id="element-1027" data-mp="1sjgslgemcu56">
          <text x="0" y="12" fontFamily="Arial, Helvetica, sans-serif" fontSize="10" fontWeight="700" data-id="element-1028" data-mp="1xi0fbj11e9yl">
            <tspan fill="#4285F4" data-id="element-1029" data-mp="1itnikju4kn31">G</tspan>
            <tspan fill="#EA4335" data-id="element-1030" data-mp="1isughw642lr8">o</tspan>
            <tspan fill="#FBBC05" data-id="element-1031" data-mp="1nsgtq5lxw201">o</tspan>
            <tspan fill="#4285F4" data-id="element-1032" data-mp="1nr5r4948d0ai">g</tspan>
            <tspan fill="#34A853" data-id="element-1033" data-mp="1nq44d7duqpcy">l</tspan>
            <tspan fill="#EA4335" data-id="element-1034" data-mp="2bht438t06g3x">e</tspan>
          </text>
          <text x="38" y="12" fill="#5F6368" fontFamily="Arial, Helvetica, sans-serif" fontSize="10" fontWeight="600" data-id="element-1035" data-mp="2bg895i2s0v5j">
            Pay
          </text>
        </svg>
      </li>

      <li className={tile} title="Shop Pay" data-id="element-1036" data-mp="slrds7pyktjx">
        <svg viewBox="0 0 52 16" className="h-4 w-[46px]" role="img" aria-label="Shop Pay" data-id="element-1037" data-mp="nktvzw8v21iy">
          <rect width="52" height="16" rx="3" fill="#5A31F4" data-id="element-1038" data-mp="im0dtqimpmcg" />
          <text x="26" y="11.5" textAnchor="middle" fill="#FFFFFF" fontFamily="Arial, Helvetica, sans-serif" fontSize="8" fontWeight="700" letterSpacing="0.3" data-id="element-1039" data-mp="iocve2kh5uoz">
            shop Pay
          </text>
        </svg>
      </li>
    </ul>;
}